



















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class PageLanguageComponent extends Vue {  
  isLoading = false;
  items: string[] = [];
  async created() {
    this.isLoading = true;
    this.items = ((await this.$api.LanguageService.getLanguagesAsync()) || []).map(x=>x.toString());
    this.isLoading = false;
  }
}
